import React, { useEffect, useState } from "react";

import homepageLogoUrl from "@/assets/icons/svg/logo-dnb-white.svg";

import logoAmpersandWhite from "@/assets/icons/svg/footer-logo-ampersand-white.svg";
import iconGlobe from "@/assets/icons/svg/footer-icon-globe.svg";
import iconCheck from "@/resources/optimized/your_privacy_choices_footer.svg";

import WebScreen from "./WebScreen";
import MobileScreen from "./MobileScreen";

import footerData from "./Ifooter";
import footerDataFromJson from "./FooterData";
import { isNotUndefinedOrNull } from "@/shared/FunctionCore";


const Footer = ({ countryCode }): JSX.Element => {
  const [footerData, setFooterData] = useState<footerData>();
  useEffect(() => {
    const getFooterDataBasedOnLanguage = () => {
      const footerData = footerDataFromJson[countryCode];
      setFooterData(footerData);
    };
    getFooterDataBasedOnLanguage();
  }, [countryCode]);

  const openCookiePopup = () => {
    try {
      const trusteRef = window["truste"];
      if (isNotUndefinedOrNull(trusteRef)) {
        trusteRef.eu.clickListener();}
      } catch {}
  };

  const homeRedirection = footerData?.homeRedirection;

  return (
    <>
    <div className="page-footer">
      <div className="container-fluid footer-wrapper">
        <div className="row">
          <div className="col-md-12 col-lg-3">
            <div >
                <a 
                  href={homeRedirection}
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = homeRedirection ?? '/';
                  }}>
                    <div className="logo">
                      <img
                        alt="Dun and Bradstreet Logo"
                        className="desktop"
                        src={homepageLogoUrl}
                      />
                      <img
                        alt="Dun and Bradstreet Logo"
                        className="mobile"
                        src={homepageLogoUrl}
                        width= "240"
                        height= "36"
                      />
                      {/* <a href={footerData?.globeRedirection}>
                      <img
                        alt="international site selector"
                        className="mobile float-right"
                        height="42"
                        src={iconGlobe}
                        width="30"
                      />
                      </a> */}
                  </div>
                </a>
                {footerData?.footerDescription && footerData?.footerDescription !== '' && (
                  <div className="logo_dsc">
                    {footerData?.footerDescription}
                  </div>
                )}
                {footerData?.contactUs && footerData?.contactUs !== '' && (
                  <div className="contact_us">
                    <a href={footerData?.contactUs}>{footerData?.contactUsLabel}</a>
                  </div>
                )}
                <div className="social_links">
                  <div className="socialLinksWrapper">
                    <ul>
                      {footerData && footerData.socialSiteSection && footerData.socialSiteSection.map((social, index) => <li className="logoMargin" key={index}>
                      <a aria-label={social['ariaLabel']}
                          href={social['redirection']}
                          target={social['target']}
                          className={`${social.className} footer-social-site-icon`}>
                      </a>
                      </li>)}
                    </ul>
                  </div>
                </div>
              </div>
          </div>

          <div className="col-md-12 col-lg-9 site-links">
            <div className="html_links html">
              <div className="row">
                 <WebScreen topSection={footerData?.topSection} /> 
                 <MobileScreen topSection={footerData?.topSection} />
              </div>
            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="html_legal html">
              <div className="footer-sub">
                 {footerData?.bottomSection.map((row, index) => 
                   <div className="footer-row-sub" key={index}>
                     <>

                       {row.map((bottomSection, i) => (
                         <li key={i}>
                           {!bottomSection['cookieRedirection'] &&
                             <a href={bottomSection['redirection']} className={`list-default-color 
                          ${bottomSection['target'] === "_blank" ? 'ext-icon' : void 0}
                          ${!bottomSection['redirection'] ? 'disableAnchorLink' : void 0}`
                             }
                               target={bottomSection['target']}>
                               {bottomSection['label']}
                               {/* {bottomSection['label'] === "Your Privacy Choices" ? <img src={iconCheck} style={{ height: '18px', verticalAlign: 'middle', paddingLeft: '4px' }} /> : null} */}
                             </a>}
                           {bottomSection['cookieRedirection'] && <a onClick={openCookiePopup} className={`list-default-color cursor-pointer ${bottomSection['target'] === "_blank" ? 'ext-icon' : void 0}`} target={bottomSection['target']}>{bottomSection['label']}</a>}
                         </li>
                       ))}
                     </>
                   </div>
                )}
              </div>
              {footerData?.companyRightsLabel !== '' && (
                <div className="footer-rights">
                {footerData?.companyRightsLabel}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default Footer;